import { ResultBase } from '@modules/test-development/models/result-base.model';
import { EnvironmentResult } from '@testsigmainc/models';
import { ResultConstant } from '@testsigmainc/constants';
import {
  custom,
  deserialize,
  getDefaultModelSchema,
  object,
  optional,
  serializable,
  SKIP,
} from 'serializr';
import { PageObject } from '../../../models/page-object.model';
import { EntityType } from '../enums/entity-type.enum';
import { TestSuiteResultSession } from './test-suite-result-session.model';
import { TestSuite } from './test-suite.model';

export class TestSuiteResultMetric {
  @serializable(
    custom(
      (v) => SKIP,
      (v) => v,
    ),
  )
  public latestResult: ResultConstant;

  @serializable
  totalCount: number;

  @serializable
  failedCount: number;

  @serializable
  passedCount: number;

  @serializable
  stoppedCount: number;

  @serializable
  notExecutedCount: number;

  @serializable
  queuedCount: number;

  @serializable
  runningCount: number;

  @serializable
  consolidatedTotalCount: number;

  @serializable
  consolidatedFailedCount: number;

  @serializable
  consolidatedPassedCount: number;

  @serializable
  consolidatedStoppedCount: number;

  @serializable
  consolidatedNotExecutedCount: number;

  @serializable
  consolidatedQueuedCount: number;

  @serializable
  consolidatedRunningCount: number;

  @serializable
  duration: number;

  @serializable
  consolidatedDuration: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestSuiteResultMetric, input));
  }
}

export class TestSuiteResult extends ResultBase implements PageObject {
  // self reference is not supported in babel 6.X
  // reference: https://www.npmjs.com/package/serializr
  constructor() {
    super();
    getDefaultModelSchema(TestSuiteResult).props['lastReRunResult'] = optional(
      object(TestSuiteResult),
    );
  }
  @serializable
  public environmentResultId: number;

  @serializable
  public suiteId: number;

  @serializable
  public message: string;

  @serializable
  public position: number;

  @serializable(
    custom(
      () => SKIP,
      (v) => {
        return new TestSuite().deserialize(v);
      },
    ),
  )
  public testSuite: TestSuite;

  @serializable(optional(object(EnvironmentResult)))
  public environmentResult: EnvironmentResult;

  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public sessionId: string;

  @serializable
  public videoURL: URL;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public logURLS: Map<string, URL>;

  @serializable
  public reRunParentId: number;

  @serializable(optional(object(TestSuiteResultSession)))
  public testSuiteResultSession: TestSuiteResultSession;

  @serializable(optional(object(TestSuiteResultMetric)))
  public testSuiteResultMetric: TestSuiteResultMetric;

  public consolidatedPassedCount: number = 0;

  @serializable
  public consolidatedDuration: number;

  @serializable
  public runTestCasesInParallel: boolean;

  @serializable
  public entityType: EntityType;

  @serializable
  public lastReRunResult: TestSuiteResult;

  get lastRun() {
    if (this.lastReRunResult != null) return this.lastReRunResult;
    return this;
  }

  get isAfterSuiteResult() {
    return this.entityType == EntityType.AFTER_TEST_SUITE_RESULT;
  }

  get isLatestRunExecuting() {
    return (
      this.testSuiteResultMetric?.latestResult == ResultConstant.RUNNING ||
      this.testSuiteResultMetric?.latestResult == ResultConstant.QUEUED
    );
  }

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestSuiteResult, input));
  }
}
